(function ($, app, api) {
	var $def = new $.Deferred();

	app.onLoad(function () {
		(function () {

			if (!app) {
				$def.resolve();
				app.NRNoticeError('Marketing Event is NOT working, because of no API instance');
				return;
			}

			/*
				(['a', 'b', 'c'], cb) => [[a, cb(a)], [b, cb(b)], [c, cb(c)]]
				If cb('a') will return false then will no 'a' param in the result.
			*/
			var _mapParams = function (params, cb) {
				return _.filter(_.zip(params, _.map(params, cb)), _.last);
			};

			// [[a, cb(a)], [b, cb(b)], [c, cb(c)]] => 'a=cb(a)&b=cb(b)&c=cb(c)'
			var _paramsToQueryString = function (params) {
				return _.invoke(params, 'join', '=').join('&');
			};

			/*
				Get ref domain.
				If referrer === host (without 'm' and 'www' prefixes) then return null.
			*/
			var _getRefDomain = function () {
				var refDomain = document.referrer && document.referrer.match(/:\/\/(.[^/]+)/)[1],
					deletePrefixRegexp = new RegExp(/^(m||www)\./i);

				if (refDomain && refDomain.replace(deletePrefixRegexp, '') === document.location.host.replace(deletePrefixRegexp, '')) {
					return null;
				} else {
					return refDomain;
				}
			};

			/*
				Build marketing data:
					If baseParams are present in query string or value of param fallbackQueryString then
					check for optParams (and add values if it present). Also it adds referrer domain to the data
					if referrer is present.
			*/
			var _buildMarketingData = function (baseParams, optParams, fallbackQueryString, refDomain, refParamName) {
				var queryParamGetter = function (name) {
					return app.globalQueryParams.get(name)
						|| app.globalQueryParams.get(name, decodeURIComponent(app.globalQueryParams.get(fallbackQueryString)));
				};

				var data = _mapParams(baseParams, queryParamGetter);

				data = data.length && data.concat(_mapParams(optParams, queryParamGetter));
				data = data.length && refDomain && data.concat([[refParamName, refDomain]]) || data;

				return data;
			};

			// Opts.
			var opts = {
				baseParams: ['referredBy', 'ui', 'sc', 'c', 'ca'],
				optParams: ['saleID', 'productID', 'image'],
				fallbackQueryString: 'ReturnUrl',
				refDomain: _getRefDomain(),
				refParamName: 'referrer'
			};
			var data = _buildMarketingData(opts.baseParams, opts.optParams, opts.fallbackQueryString, opts.refDomain, opts.refParamName);

			// Track.
			if (data.length) {
				api.setMarketingData(_paramsToQueryString(data), { hideErrors: true })
					.always($def.resolve);
			} else {
				$def.resolve();
			}

			// Instance of API will be provided by some scripts NOT from OzSale.Scripts.
		})();
	});

	app.marketingXhr = $def.promise();
})(jQuery, app, api);

window.app.enteredSale = (function (app, api) {

	return function (data, callback) {
		if (!api) {
			app.NRNoticeError('Entered Sale Event is NOT working, because of no API instance');
			return;
		}

		app.marketingXhr.done(function () {
			api.enteredSale(data, { hideErrors: true }).done(callback);
		});
	}

})(app, api);

window.app.enteredSaleItem = (function (app, api) {

	return function (data, callback) {
		if (!api) {
			app.NRNoticeError('Entered Sale Event is NOT working, because of no API instance');
			return;
		}

		app.marketingXhr.done(function () {
			api.enteredSaleItem(data, { hideErrors: true }).done(callback);
		});
	}

})(app, api);